import React from 'react';
import './nav-bar.css';
import { useCTAL } from './CTAL_Hooks.js';

const app_version = "v1.0"; //First "public release"

export default function TopBar({sign_out}) 
{
    const { setAppUser, setUserID, setTeam, setTeamMemberRole, setTeamID, setActionItem, setShortTermGoal,
            setUserShortList, setUserLongList, setUserPublicTeamList, setUserTeamInvitationsList, setUserJoinRequestsList,
            setNewActionItemFlag, setSelectedActionItem  } = useCTAL();

    const app_sign_out = () => { 
        //Clear Data
        setAppUser(undefined);
        setUserID("");
        setTeam(undefined);
        setTeamMemberRole("");
        setTeamID("");
        setActionItem(undefined);
        setShortTermGoal(undefined);

        setUserShortList(undefined);
        setUserLongList(undefined);
        setUserPublicTeamList([]);
        setUserTeamInvitationsList([]);
        setUserJoinRequestsList([]);
    
        setNewActionItemFlag(false);
        setSelectedActionItem();

        sign_out();
    }

    return (
        <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light fixed-top py-1" id="navigation-bar-container">
                <div className="container-fluid">
                    <a href="#" onClick={ () => window.location.reload(true) }><img id="ctal-logo" src="checklist.svg" alt="logo" border="0"/></a>

                    <a className="navbar-brand me-auto" href="#" onClick={ () => window.location.reload(true) }>Call to Action List</a>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" 
                            data-bs-target="#navbar" 
                            aria-controls="navbar"
                            aria-expanded="false" 
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                
                    <div className="navbar-collapse collapse" id="navbar">

                        <ul className="navbar-nav mb-lg-0 ms-auto">
                            <li className="nav-item"><a className="nav-link" href="mailto:admin@calltoactionlist.com?subject=Call%20To%20Action%20List%20Inquiry">Contact Us</a></li>
                            <li className="nav-item"><a className="nav-link" href="#" onClick={ () => app_sign_out() }>Sign Out</a></li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
}

/*
    October 10, 2023 removed Action Search and Account Menu options for v1.0

                        <form className="form-inline ms-auto">
                            <div className="input-group input-group-sm" >
                            <input type="text" className="form-control" placeholder="Enter Action Number" aria-label="action item search" aria-describedby="ai-search"/>
                            <button className="btn btn-outline-secondary" type="button" id="ai-search">
                                <img src="./images/search.svg" alt="search" border="0"/>
                            </button>
                            </div>  
                        </form>


                            <li className="nav-item"><a className="nav-link" href="#">Account</a></li>

*/